var map = {
	"./img22-1.png": 69240,
	"./img22.png": 78318,
	"./tips.png": 33573,
	"./tips1.png": 87623,
	"./tips10.png": 17064,
	"./tips11.png": 16496,
	"./tips12.png": 53789,
	"./tips2.png": 80674,
	"./tips3.png": 53075,
	"./tips4.png": 26996,
	"./tips5.png": 39913,
	"./tips6.png": 8264,
	"./tips7.png": 29417,
	"./tips8.png": 23052,
	"./tips9.png": 88997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39800;